<agr-form [formGroup]="formGroup">
  <div class="flex--row flex--nowrap fertilizationsetting-row spacing--margin-top">
    <div class="flex--column flex--nowrap">
      <div class="flex--row flex--nowrap text--label edit-row margin-top options-row">
        <mat-form-field
          class="flex__child--0 spacing--padding-half-left edit-row__fertilization_cropAdvice_name"
        >
          <mat-label>{{ 'cropAdviceName' | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="cropAdviceName"
            data-test="quickedit-fertilizationSetting-cropAdviceName"
            readonly
          />
        </mat-form-field>

        <mat-form-field
          class="flex__child--0 spacing--padding-half-left edit-row__fertilization_crop_name"
        >
          <mat-label>{{ 'crop' | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="cropName"
            data-test="quickedit-fertilizationSetting-cropName"
            readonly
          />
        </mat-form-field>

        @if ((nitrogenCalculationSettingToggles$ | async)?.shouldShowOrganicMatterToggle) {
          <div>
            <mat-form-field
              class="flex__child--auto spacing--padding-half-left edit-row__organicMatterSupply"
            >
              <mat-label>
                {{ 'organicMatterSupply' | translate }}
                @if (isPrefilling$ | async) {
                  <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
                }
              </mat-label>
              <mat-select
                formControlName="organicMatterSupply"
                [placeholder]="'organicMatterSupply' | translate"
                data-test="quickedit-fertilizationsetting-organicMatterSupply"
              >
                @for (organicMatterSupply of organicMatterSupplyKeys; track organicMatterSupply) {
                  <mat-option [value]="organicMatterSupply">
                    {{ organicMatterSupply | lowercase | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <mat-form-field class="flex__child--auto spacing--padding-half-left edit-row__cropyield">
          <mat-label>{{ 'expectedCropYield' | translate }} (T)</mat-label>
          <input
            matInput
            agrNumber
            maxlength="10"
            [placeholder]="'expectedCropYield' | translate"
            formControlName="expectedCropYield"
            [step]="0.1"
            autocomplete="off"
            data-test="quickedit-fertilization-setting-expected-crop-yield"
          />
        </mat-form-field>

        <div
          *ngrxLet="cropYear$ as cropYear"
          class="flex--row flex--nowrap text--label options-row spacing--margin-bottom"
          [ngClass]="{
            'edit-row__expandable_toggles': cropYear < 2025,
          }"
        >
          <div class="flex--column spacing--padding-half-left edit-row__default_toggles">
            <mat-label
              class="flex__child--0 spacing--padding-half-left text--label edit-row__options edit-row__padding_label text--left"
              >{{ 'shouldBeUsed' | translate }}</mat-label
            >
            <mat-slide-toggle
              color="primary"
              formControlName="shouldBeUsedInUsageStandard"
              data-test="quickedit-fertilization-setting-should-be-used-in-usage-standard"
              class="flex--justify-left spacing--padding-left text--label"
            >
              {{ 'shouldBeUsedInUsageStandard' | translate }}
            </mat-slide-toggle>
            <mat-slide-toggle
              color="primary"
              formControlName="shouldBeUsedInLegalStandard"
              data-test="quickedit-fertilization-setting-should-be-used-in-legal-standard"
              class="flex--justify-left spacing--padding-left text--label"
            >
              {{ 'shouldBeUsedInLegalStandard' | translate }}
            </mat-slide-toggle>
          </div>

          @if (cropYear < 2025) {
            <div class="flex--column spacing--padding-half-left edit-row__default_toggles">
              <mat-label
                class="flex__child--0 spacing--padding-half-left text--label edit-row__options text--left"
                >{{ 'phosphateArrangements' | translate }}</mat-label
              >
              <mat-slide-toggle
                color="primary"
                formControlName="shouldUseTransitionalArrangement"
                data-test="quickedit-fertilization-setting-should-use-transitional-arrangement"
                class="flex--justify-left spacing--padding-left text--label"
              >
                {{ 'shouldUseTransitionalArrangement' | translate }}
              </mat-slide-toggle>
              <mat-slide-toggle
                color="primary"
                formControlName="shouldUseLowInPhosphateArrangement"
                data-test="quickedit-fertilization-setting-should-use-low-in-phosphate-arrangement"
                class="flex--justify-left spacing--padding-left text--label"
              >
                <span class="edit-row__phosphate_norm">{{
                  'shouldUseLowInPhosphateArrangement' | translate
                }}</span>
              </mat-slide-toggle>
            </div>
          }
        </div>

        <div class="edit-row__default_toggles">
          <mat-label
            class="flex__child--0 spacing--padding-half-left text--label edit-row__options text--left"
          >
            {{ 'nitrogenUsageStandard' | translate }}
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
          </mat-label>

          <div class="spacing--padding-left text--label">
            @if (isPrefilling$ | async) {
              <mat-spinner class="prefill-spinner" [diameter]="16"></mat-spinner>
            }
            <app-nitrogen-calculation-settings
              [nitrogenCalculationSettingsFormGroup]="getNitrogenCalculationSettingsFormGroup()"
              [nitrogenCalculationSettingToggles]="nitrogenCalculationSettingToggles$ | async"
              [hideLabel]="true"
            ></app-nitrogen-calculation-settings>
          </div>
        </div>
      </div>

      <div
        class="flex--row flex--nowrap text--label options-row spacing--margin-bottom edit-row__expandable_toggles"
      >
        <div class="">
          <mat-slide-toggle
            color="primary"
            formControlName="isPrecedingCrop"
            data-test="quickedit-isPrecedingCrop-isPrecedingCrop"
            class="flex--justify-left spacing--padding-left text--label"
            >{{ 'isPrecedingCrop' | translate }}
          </mat-slide-toggle>

          @if (isPrecedingCrop()) {
            <app-preceding-crop-settings
              [precedingCropFormGroup]="getPrecedingCropFormGroup()"
              [crops]="data.crops"
              data-test="fertilization-setting-detail-preceding-crop-settings"
              class="spacing--padding-left"
            ></app-preceding-crop-settings>
          }
        </div>

        <div class="spacing--padding-half-left">
          <mat-slide-toggle
            color="primary"
            formControlName="isGreenManure"
            data-test="quickedit-isGreenManure-isGreenManure"
            class="flex--justify-left spacing--padding-left text--label"
            >{{ 'isGreenManure' | translate }}
          </mat-slide-toggle>

          @if (isGreenManure()) {
            <app-green-manure-settings
              [crops]="data.greenManureCrops"
              [greenManureFormGroup]="getGreenManureFormGroup()"
              data-test="fertilization-setting-detail-green-manure-settings"
              class="spacing--padding-left"
            ></app-green-manure-settings>
          }
        </div>
      </div>
    </div>
  </div>
</agr-form>
